(() => {
  const header = document.querySelector('.t4s-is-header-categories-menu');
  const wrap = header?.querySelector('.t4s-search-header__form-wrap');
  const input = wrap?.querySelector('[data-input-search]');
  if (!input || wrap.dataset.phSearchReady) return;
  wrap.dataset.phSearchReady = 'true';
  const mobile = matchMedia('(max-width:767px)');
  const cancel = document.createElement('button');
  cancel.type = 'button'; cancel.className = 'ph-search-cancel'; cancel.textContent = 'Cancel';
  wrap.append(cancel);
  const shade = document.createElement('button');
  shade.type = 'button'; shade.className = 'ph-search-shade'; shade.setAttribute('aria-label','Close search');
  document.body.append(shade);
  input.setAttribute('aria-label','Search products');
  wrap.querySelector('[type="submit"]').setAttribute('aria-label','Search');
  header.querySelector('[data-menu-drawer]')?.setAttribute('aria-label','Open menu');
  header.querySelector('.t4s-header__logo a')?.setAttribute('aria-label','Pawesome House home');
  function sync() { wrap.classList.toggle('ph-has-query', !!input.value.trim()); }
  function open() {
    if (!mobile.matches) return;
    if (input.classList.contains('snize-input-style')) return;
    document.documentElement.classList.add('ph-search-open');
    sync(); input.setAttribute('aria-expanded','true');
  }
  function close() {
    document.documentElement.classList.remove('ph-search-open');
    input.setAttribute('aria-expanded','false'); input.blur();
  }
  input.addEventListener('focus',open);
  input.addEventListener('input',sync);
  cancel.addEventListener('click',close); shade.addEventListener('click',close);
  document.addEventListener('keydown', e => { if(e.key==='Escape') close(); });
  header.querySelector('[data-menu-drawer]')?.addEventListener('click',close);
  mobile.addEventListener('change', () => { if(!mobile.matches) close(); });
})();

(() => {
  const wrap=document.querySelector('.t4s-is-header-categories-menu .t4s-search-header__form-wrap');
  const input=wrap?.querySelector('[data-input-search]');
  const cancel=wrap?.querySelector('.ph-search-cancel');
  const submit=wrap?.querySelector('[type="submit"]');
  if(!input || !cancel || !submit || wrap.querySelector('.ph-search-clear'))return;
  const mobile=matchMedia('(max-width:767px)'),root=document.documentElement;
  const clear=document.createElement('button');
  clear.type='button';clear.className='ph-search-clear';clear.setAttribute('aria-label','Clear search');
  clear.innerHTML='<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  submit.before(clear);
  cancel.setAttribute('aria-label','Cancel search');
  function sync(){wrap.classList.toggle('ph-mobile-has-text',input.value.length>0);}
  function open(){
    if(!mobile.matches)return;
    root.classList.remove('ph-mobile-search-dismissed');
    wrap.classList.add('ph-mobile-search-active');sync();
  }
  function close(){
    if(!mobile.matches)return;
    wrap.classList.remove('ph-mobile-search-active');
    root.classList.add('ph-mobile-search-dismissed');
    root.classList.remove('ph-search-open','ph-searchanise-open');
    input.dispatchEvent(new KeyboardEvent('keydown',{key:'Escape',code:'Escape',keyCode:27,which:27,bubbles:true}));
    input.blur();input.setAttribute('aria-expanded','false');
    wrap.removeAttribute('open');
  }
  clear.addEventListener('pointerdown',e=>e.preventDefault());
  clear.addEventListener('click',()=>{
    if(!mobile.matches)return;
    input.value='';input.focus({preventScroll:true});open();
    input.dispatchEvent(new Event('input',{bubbles:true}));
    input.dispatchEvent(new KeyboardEvent('keyup',{key:'Backspace',code:'Backspace',keyCode:8,which:8,bubbles:true}));
    sync();
  });
  input.addEventListener('focus',open);input.addEventListener('input',()=>{open();sync();});
  cancel.addEventListener('click',close);
  document.addEventListener('pointerdown',e=>{
    if(mobile.matches && wrap.classList.contains('ph-mobile-search-active') &&
       !wrap.contains(e.target) && !e.target.closest?.('#snize-instant-search-results'))close();
  });
  input.addEventListener('keydown',e=>{
    if(e.key==='Escape' && wrap.classList.contains('ph-mobile-search-active'))close();
  });
  mobile.addEventListener('change',()=>{
    if(!mobile.matches){wrap.classList.remove('ph-mobile-search-active');root.classList.remove('ph-mobile-search-dismissed');}
  });
  sync();if(document.activeElement===input)open();
})();
